import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'quizzes';

const list = (params: any) => EndPointService.get(`/${ROUTE}/answers`, params);
const update = (id: string, data: { title: string }) => EndPointService.patch(`/${ROUTE}/answers/${id}`, data);

export default {
    list,
    update,
};
